// External
import { Injectable } from '@angular/core';
import { ConfigJsInterface, ConfigServiceInterface, ParameterPlaceholders } from '../models/Config.model';

export const BITDEFENDER_PARTNER_ID = 'com.bitdefender';
export const NETGEAR_PARTNER_ID = 'com.netgear';
export const GOOGLE_API_KEY = 'AIzaSyAZ67mrS5XP40xoeTOFQyaUhsyGsOJIv3U';

export enum  DeployType {
    BETA = 'beta',
    PROD = 'prod',
    ALPHA = 'alpha'
}

export enum AccountVersion {
    EXTERNAL = 1,
    INTERNAL = 2
}

export enum Hosts {
    BETA = 'beta-central.bitdefender.com',
    ALPHA = 'alpha-central.bitdefender.com',
    STAGE = 'stage.central.nmbapp.net',
    PRODUCTION = 'central.bitdefender.com',
    LOCAL = 'v2.central.bitdefender.com',
    TEST_1 = 'test1.central.nmbapp.net',
    TEST_2 = 'test2.central.nmbapp.net',
    TEST_3 = 'test3.central.nmbapp.net',
    TEST_4 = 'test4.central.nmbapp.net',
    DEFAULT = 'default'
}

/**
 * For Central we log console errors to 'sentryDSNCentralAngular' and requests error to 'sentryDSNCentralConnect'
 * For oem partners we do not usually need 2 projects to log errors so these 2 will have the same value
 */
export enum SentryDSN {
    CENTRAL = 'https://04955dff982e3d8114ad671cb9c648ef@o4504802466004992.ingest.us.sentry.io/4506677715271680',
    BETA_CENTRAL = 'https://04955dff982e3d8114ad671cb9c648ef@o4504802466004992.ingest.us.sentry.io/4506677715271680'
}

/**
 * Describes what you use from the config.service.ts config properties
 * For central bitdefender, login server === logout server, login params === logout params and login path === logout path, but
 * for oem partners this might not be the case
 */
export enum LogoutType {
    REDIRECT_TO_LOGIN_PAGE = 'redirect_to_login_page', // redirect: login server + login path + login params
    REDIRECT_TO_LOGOUT_PAGE = 'redirect_to_logout_page', // redirect: logout server + logout path + logout params
    REDIRECT_TO_RELOGIN_PAGE = 'redirect_to_relogin_page', // redirect: login server + relogin path + relogin params
    NO_REDIRECT = 'no_redirect' // redirect: no redirect
}

@Injectable({
    providedIn: 'root'
})


export class ConfigService {

    config = {} as ConfigServiceInterface;
    conditions: any = {};
    // this variable should not be changed
    private readonly centralBitdefenderSiteUrl = 'https://central.bitdefender.com';
    private readonly centralBetaBitdefenderSiteUrl = 'https://beta-central.bitdefender.com';
    private readonly centralAlphaBitdefenderSiteUrl = 'https://alpha-central.bitdefender.com';
    private configJs: ConfigJsInterface = window?.['_glCnfg'];

    prodConfig: ConfigServiceInterface = {
        // * Used in Development
        outletEventsTracking  : false,
        // * Core values
        //#region
        nimbusClientId        : this.configJs?.nimbusClientId ? this.configJs.nimbusClientId : 'fdb6cb3c-3953-4416-813a-bb39104dd869', // Central V2
        type                  : DeployType.PROD,
        partner_id            : this.configJs?.partner_id ? this.configJs.partner_id : 'com.sourcenext',
        manufacturerName      : 'スーパーセキュリティ',
        manufacturerNameBox   : 'スーパーセキュリティ Box',
        siteName              : this.configJs?.siteName ? this.configJs.siteName : 'Central',
        defaultTheme          : 'default',
        themes                : false,
        pathImages            : '/ux/images/',
        pathIcons             : '/ux/icons/',
        logo                  : '/ux/images/logo/logo.svg', // app logo, if left empty manufacturerLogo will act as default
        manufacturerLogo      : '/ux/images/logo/manufacturerLogo.svg', // default logo, if left empty text logo will be default
        siteUrl               : this.configJs?.siteUrl ? this.configJs.siteUrl : 'https://central.bitdefender.com',
        avangateFrameParam    : '&MYACCOUNTSTYLE=nLWsnpTfpro=',
        mainPage              : '/dashboard', // first page of the website
        idTPIframeLink        : 'https://bitdefender.identityforce.com/app/.ssohandler',
        idTPIframeOrigin      : 'https://bitdefender.identityforce.com',
        // cookiesDomain should be modified only after careful testing of logout and cookie deletion, most likely should not be modified at all
        cookiesDomain: this.configJs?.cookiesDomain ? this.configJs.cookiesDomain : '.central.bitdefender',
        cookieConsent: false,
        // ! To be removed after proper init of products names
        boxName                           : 'スーパーセキュリティ Box',
        //#endregion

        // * Backend URLs and Login Configuration
        //#region
        // nimbusServer           : 'https://v2.central.bitdefender.com/nimbus/',
        nimbusServer           : 'https://nimbus.bitdefender.net/',
        connectNimbusServer    : 'https://connect.nimbus.bitdefender.net/',
        katastifServer         : 'https://nimbus.bitdefender.net/',
        atoServer              : 'https://nimbus.bitdefender.net/',
        securePassServer       : 'https://securepass-auth.bitdefender.com/',

        gmailAuth: {
            clientId: '97599827433-7sr5c4t4r2id4vgld1455omcmt465qci.apps.googleusercontent.com'
        },
        outlookAuth: {
            clientId: '2b37c4e4-f547-4076-8233-aec27bb28ad9',
        },
        loginCreateServer          : 'https://login.bitdefender.com/signup',
        loginChangeEmail             : 'https://login.bitdefender.com/validate',
        externalAccountLink        : 'https://account.bitdefender.com',
        externalPasswordAccountLink: 'https://account.bitdefender.com/password',
        externalAuthenticationAccountLink: 'https://account.bitdefender.com/authentication',
        parentalNccDefaultAvatars  : 'https://download.bitdefender.com/resourcesv3/ncc/avatars/',
        googleMapsApi              : 'https://maps.googleapis.com/maps/api/js',

        useClientIds: true,
        clientIds: {
            "central.sourcenext.info": "LimdrwQuC4wYgJrj",
            "sourcenext.oem-central-stage.bitdefender.com": "PDHHfGCV7UcmzFy7",
            "sourcenext.central-oem.nmbapp.net": "PDHHfGCV7UcmzFy7",
        },
        loginUserTokenName: 'code',

        loginServer: this.configJs?.loginServer ? this.configJs.loginServer : 'https://www.sourcenext.com/',
        loginPath: this.configJs?.loginPath ? this.configJs.loginPath : 'rmsweb/login',
        loginParams: this.configJs?.loginParams
                    ? this.configJs.loginParams
                    : {
                        response_type : 'code',
                        client_id     : '$client_id',
                        redirect_uri  : `https://${location.host}`,
                        lang          : 'jp',
                    },
        reloginParams: {
            redirect_url: ParameterPlaceholders.REDIRECT_URL,
            lang        : ParameterPlaceholders.LANG,
            user        : ParameterPlaceholders.EMAIL,
            des         : 'welcome'
        },
        logoutServer: this.configJs?.logoutServer ? this.configJs.logoutServer : 'https://www.sourcenext.com/',
        logoutPath: this.configJs?.logoutPath ? this.configJs.logoutPath : 'logout',
        logoutParams: this.configJs?.logoutParams
                    ? this.configJs.logoutParams
                    : {
                        adobe_mc_ref  : ParameterPlaceholders.REF,
                        redirect_url  : ParameterPlaceholders.REDIRECT_URL,
                        lang          : ParameterPlaceholders.LANG,
                        partner_id    : ParameterPlaceholders.PARTNER_ID,
                    },
        // ? posible values: host, host:path, host:path:query, host:query. Everything else translates to only <host>
        loginRedirectUrlType: 'host:path:query', // this is used for both login and logout and is not configurable for both of them
        autolookupPath: 'central/password.html',
        defaultLoginUserTokenName: 'user_token',

        registerServer: this.configJs?.registerServer ? this.configJs.registerServer : 'https://www.sourcenext.com/',
        registerPath      : 'rmsweb/signup',
        registerParams    : {
            response_type : 'code',
            client_id     : '$client_id',
            redirect_uri  : `https://${location.host}`,
            lang          : 'jp'
        },
        ts_trial_id: '638e184d-bbbc-44b8-b94a-544c6d1d3832', //! delete this for OEM parteners
        //#endregion

        // * Modules switches
        //#region
        notifications     : true, // Notifications drawer
        premium           : false, // Premium services
        privacyTabs: {
            activity: true,
            footprint  : true,
            breaches  : true,
            impersonations  : true,
            brokers  : true,
            education: true,
            history: true,
            monitor: true,
            remedies: true
        },
        privacyChat: true,
        subscriptions     : false, // Subscriptions
        subscriptionsTabs : {
            billing : false,
            invoices: false,
            payments: false
        },
        autoRenewalFlow: true,
        subscriptionsSdk: false,
        multiplePaymentCards: false,
        quickActions: {
            malwareScan       : true,
            antitheft         : true,
            optimizer         : true,
            vulnerabilityScan : true,
            scan              : true
        },
        offers            : false, // Remove offers module + navigation
        support           : true, // Remove support button from left menu
        community         : false,
        thirdparty        : false,
        terms             : false, // Remove Terms of service link
        poweredBy         : false, // Show 'powered by Bitdefender' logo
        dashboard         : true, // remove dashboard page. this is also changeable in different files in the app.
        omniture          : false,
        devicesTab        : true, //! De redenumit :-<
        business: {
            dashboard: true
        },
        dashboardCards: {
            recommendations: false,
            securityNews: false,
            appBanner: false
        },
        referral          : false,
        info              : false,
        onboardingMSP     : false, // Remove Onboarding MSP
        qrCode            : false, // Display QR Code on install flow

        family: {
            dashboard: true
        },

        automaticTrialActivation: false,
        //#endregion

        // Support
        internalSupport: true,
        externalSupport: true,
        externalSupportLink: '',
        supportCards: {
            phone: false,
            email: false,
            search: false
        },
        //#endregion

        // * Home Module
        //#region
        home: this.configJs?.home ?? false, // Homepage
        homeSections: {
            capabilities: true,
            capabilitiesList: {
                deviceProtection: true,
                remoteActions: true,
                installProtection: true,
                manageServices: true,
                parentalControl: true,
                industryInsights: true
            },
            products: true,
            appBanner: false,
        },
        //#endregion

        // * Devices Module
        //#region
        hasCustomBuyLink: false,
        //#endregion

        // * Account Module
        //#region
        account: {
            profile: true,
            sessions: false,
            settings: true,
            change_password: false,
            admin_password: true,
            delete_account: false,
            change_email: false,
            version: AccountVersion.INTERNAL
        },
        //#endregion

        // * Subscriptions Module
        //#region
        activationButtonDoRedirect: false,
        serviceDetailsLinks: {
            website: true,
            features: true,
            requirements: true
        },
        //#endregion

        // * Password Manager Module
        //#region
        passwordManagerCards: {
            needHelp: true
        },
        //#endregion

        // * VPN Module
        //#region
        vpnCards: {
            upgrade: true
        },
        //#endregion

        atoThreatsTabs: {
            devices: true,
            emailProtection: true
        },

        downloadElements: {
            footer: true,
            headerLogo: true,
            benefitsLogo: true,
            commonHelpSection: true
        },
        onBoardingSection: {
            backgroundLogo: true,
        },

        parentalNccElements: {
            useScheduleLegacy: false,
            contentFiltering: {
                module: true,
                topics: true,
                safeSearch: true,
                youtubeRestricted: true,
            },
            dtl: {
                module: true,
                reward: true,
                needMoreTime: true
            },
            routines: {
                module: true
            },
            dashboard: {
                module: true,
                location: true,
            },
            blockedContent: {
                hasCategories: false,
                hasTopics: false,
                hasWebsites: true
            },
            pin: true
        },

        ato: true,
        meta: true,

        security: true,
        securityTabs: {
            overview: true,
            webmailProtection: true
        },

        installProtection : {
            //If showLogo is true and customLogoPath is blank, the default app logo will be used
            //If showLogo is true and customLogoPath is set, the custom logo will be used
            showLogo: false, //Show logo instead of icon in install protection modal
            customLogoPath: "", // Path to logo svg file(must have id="logo") or blank for app logo
        },

        katastifService: true,
        sentryAngular: true,
        sentryConnect: true,

        rights: {
            buy: true, // buy + renew + upgrade
            buyMoreSlots: true, // buy more slots
            activateRedeem: true
        },

        pwaSettings: {
            manifestByOs: {
                windows: './assets/manifests/windows.webmanifest',
                android: './assets/manifests/android.webmanifest',
                mac: './assets/manifests/mac.webmanifest',
                ios: './assets/manifests/ios.webmanifest',
                osx: './assets/manifests/mac.webmanifest'
            },
            manifestPath: './assets/manifests/default.webmanifest',
            serviceWorkerPath: '/master-sw.js'
        },
        removeSwitchAndUpgradeSecurePassBanner:false
    };

    betaConfig: ConfigServiceInterface = {
        // * Core values
        //#region
        nimbusClientId        : this.configJs?.nimbusClientId ? this.configJs.nimbusClientId : '8fdb48f1-c968-4eae-a410-971f3fb36549', // Central V2
        type                  : DeployType.BETA,
        partner_id            : this.configJs?.partner_id ? this.configJs.partner_id : BITDEFENDER_PARTNER_ID,
        manufacturerName      : 'Bitdefender',
        manufacturerNameBox   : 'Bitdefender Box',
        siteName              : this.configJs?.siteName ? this.configJs.siteName : 'Central',
        defaultTheme          : 'default',
        themes                : false,
        pathImages            : '/ux/images/',
        pathIcons             : '/ux/icons/',
        logo                  : '/ux/images/logo/logoBeta.svg', // app logo, if left empty manufacturerLogo will act as default
        manufacturerLogo      : '/ux/images/logo/manufacturerLogo.svg', // default logo, if left empty text logo will be default
        siteUrl               : this.configJs?.siteUrl ? this.configJs.siteUrl : 'https://beta.central.bitdefender.com',
        avangateFrameParam    : '&MYACCOUNTSTYLE=nLWsnpTfpro=',
        mainPage              : '/dashboard', // first page of the website
        idTPIframeLink        : 'https://bitdefender-rakf6ypxhkjmq4ys8xe5mekepc.stage-alt.ezstest.com/app/.ssohandler',
        idTPIframeOrigin      : 'https://bitdefender-rakf6ypxhkjmq4ys8xe5mekepc.stage-alt.ezstest.com',
        // cookiesDomain should be modified only after careful testing of logout and cookie deletion, most likely should not be modified at all
        cookiesDomain: this.configJs?.cookiesDomain ? this.configJs.cookiesDomain : '.central.bitdefender',
        cookieConsent: true,
        //#endregion

        // * Backend URLs and Login Configuration
        //#region
        nimbusServer           : 'https://beta-connect-eu.nimbus.bitdefender.net/',
        connectNimbusServer    : 'https://beta-connect-eu.nimbus.bitdefender.net/',
        katastifServer         : 'https://nimbus.bitdefender.net/',
        atoServer              : 'https://beta.nimbus.bitdefender.net/',
        securePassServer       : 'https://loki-auth.bitdefender.work/',

        gmailAuth: {
            clientId: '97599827433-7sr5c4t4r2id4vgld1455omcmt465qci.apps.googleusercontent.com'
        },
        outlookAuth: {
            clientId: 'ba480ec4-33f3-4f40-bc39-e80c36ccc5f2',
        },

        loginCreateServer          : 'https://beta-login.bitdefender.com/signup',
        loginChangeEmail             : 'https://login.bitdefender.com/validate',
        externalAccountLink        : 'https://beta-account.bitdefender.com',
        externalPasswordAccountLink: 'https://account.bitdefender.com/password',
        externalAuthenticationAccountLink: 'https://account.bitdefender.com/authentication',
        parentalNccDefaultAvatars  : 'https://download.bitdefender.com/resourcesv3/ncc/avatars/',
        googleMapsApi              : 'https://maps.googleapis.com/maps/api/js',

        loginServer: this.configJs?.loginServer ? this.configJs.loginServer : 'https://beta-login.bitdefender.com/',
        loginPath: this.configJs?.loginPath ? this.configJs.loginPath : 'central/login.html',
        loginParams: this.configJs?.loginParams
                    ? this.configJs.loginParams
                    : {
                        adobe_mc_ref: ParameterPlaceholders.REF,
                        redirect_url: ParameterPlaceholders.REDIRECT_URL,
                        lang        : ParameterPlaceholders.LANG,
                        partner_id  : ParameterPlaceholders.PARTNER_ID,
                    },
        reloginParams: {
            redirect_url: ParameterPlaceholders.REDIRECT_URL,
            lang        : ParameterPlaceholders.LANG,
            user        : ParameterPlaceholders.EMAIL,
            des         : 'welcome'
        },
        logoutServer: this.configJs?.logoutServer ? this.configJs.logoutServer : 'https://beta-login.bitdefender.com/',
        logoutPath: this.configJs?.logoutPath ? this.configJs.logoutPath : 'logout',
        logoutParams: this.configJs?.logoutParams
                    ? this.configJs.logoutParams
                    : {
                        adobe_mc_ref: ParameterPlaceholders.REF,
                        redirect_url: ParameterPlaceholders.REDIRECT_URL,
                        lang        : ParameterPlaceholders.LANG,
                        partner_id  : ParameterPlaceholders.PARTNER_ID,
                    },
        // ? posible values: host, host:path, host:path:query, host:query. Everything else translates to only <host>
        loginRedirectUrlType: 'host:path:query', // this is used for both login and logout and is not configurable for both of them
        autolookupPath: 'central/password.html',
        defaultLoginUserTokenName: 'user_token',

        registerServer: this.configJs?.registerServer ? this.configJs.registerServer : 'https://beta-login.bitdefender.com/',
        registerPath  : 'central/signup.html',
        registerParams: {
            adobe_mc_ref: ParameterPlaceholders.REF,
            redirect_url: ParameterPlaceholders.REDIRECT_URL,
            lang: ParameterPlaceholders.LANG
        },
        ts_trial_id: '8a72e764-6e7c-4a0e-a02a-12c5a0b8cf78',  //! delete this for OEM parteners
        //#endregion

        // * Modules switches
        //#region
        notifications     : true, // Notifications drawer
        premium           : true, // Premium services
        privacyTabs: {
            activity: true,
            footprint  : true,
            breaches  : true,
            impersonations  : true,
            brokers  : true,
            education: true,
            history: true,
            monitor: true,
            remedies: true
        },
        privacyChat: true,
        subscriptions     : true, // Subscriptions
        subscriptionsTabs : {
            billing : true,
            invoices: true,
            payments: true
        },
        autoRenewalFlow: true,
        subscriptionsSdk: true,
        multiplePaymentCards: false,
        quickActions: {
            malwareScan       : true,
            antitheft         : true,
            optimizer         : true,
            vulnerabilityScan : true,
            scan              : true
        },
        offers            : false, // Remove offers module + navigation
        support           : true, // Remove support button from left menu
        community         : true,
        thirdparty        : true,
        terms             : true, // Remove Terms of service link
        poweredBy         : false, // Show 'powered by Bitdefender' logo
        dashboard         : true, // remove dashboard page. this is also changeable in different files in the app.
        omniture          : true,
        devicesTab        : true, //! De redenumit :-<
        business: {
            dashboard: true
        },
        dashboardCards: {
            recommendations: true,
            securityNews: true,
            appBanner: true
        },
        referral          : true,
        info              : false,
        onboardingMSP     : true, // Remove Onboarding MSP
        qrCode            : true, // Display QR Code on install flow

        family: {
            dashboard: true
        },

        automaticTrialActivation: false,
        //#endregion

        // END Root

        // Support
        internalSupport: false,
        externalSupport: true,
        externalSupportLink: '',
        supportCards: {
            phone: true,
            email: true,
            search: true
        },
        //#endregion

        // * Home Module
        //#region
        home: this.configJs?.home ?? false, // Homepage
        homeSections: {
            capabilities: true,
            capabilitiesList: {
                deviceProtection: true,
                remoteActions: true,
                installProtection: true,
                manageServices: true,
                parentalControl: true,
                industryInsights: true
            },
            products: true,
            appBanner: true,
        },
        //#endregion

        // * Devices Module
        //#region
        hasCustomBuyLink: false,
        //#endregion

        // * Account Module
        //#region
        account: {
            profile: true,
            sessions: false,
            settings: true,
            change_password: true,
            admin_password: true,
            delete_account: true,
            change_email: true,
            version: AccountVersion.EXTERNAL
        },
        //#endregion

        // * Subscriptions Module
        //#region
        activationButtonDoRedirect: false,
        serviceDetailsLinks: {
            features: true,
            requirements: true
        },
        //#endregion

        // * Password Manager Module
        //#region
        passwordManagerCards: {
            needHelp: true
        },
        //#endregion

        // * VPN Module
        //#region
        vpnCards: {
            upgrade: true
        },
        //#endregion

        atoThreatsTabs: {
            devices: true,
            emailProtection: true
        },

        downloadElements: {
            footer: true,
            headerLogo: true,
            benefitsLogo: true,
            commonHelpSection: true
        },
        onBoardingSection: {
            backgroundLogo: true,
        },

        parentalNccElements: {
            useScheduleLegacy: false,
            contentFiltering: {
                module: true,
                topics: true,
                safeSearch: true,
                youtubeRestricted: true,
            },
            dtl: {
                module: true,
                reward: true,
                needMoreTime: true
            },
            routines: {
                module: true
            },
            dashboard: {
                module: true,
                location: true,
            },
            blockedContent: {
                hasCategories: false,
                hasTopics: false,
                hasWebsites: true
            },
            pin: true
        },
        ato: true,
        meta: true,

        security: true,
        securityTabs: {
            overview: true,
            webmailProtection: true
        },

        installProtection : {
            showLogo: false, //Show logo instead of icon in install protection modal
            logoPath: "", // Path to logo svg file(must have id=logo) or blank for app logo
        },

        katastifService: true,
        sentryAngular: true,
        sentryConnect: true,

        rights: {
            buy: true, // buy + renew + upgrade
            buyMoreSlots: true, // buy more slots
            activateRedeem: true
        },

        pwaSettings: {
            manifestByOs: {
                windows: './assets/manifests/windows.webmanifest',
                android: './assets/manifests/android.webmanifest',
                mac: './assets/manifests/mac.webmanifest',
                ios: './assets/manifests/ios.webmanifest',
                osx: './assets/manifests/mac.webmanifest'
            },
            manifestPath: './assets/manifests/default.webmanifest',
            serviceWorkerPath: '/master-sw.js'
        },
        removeSwitchAndUpgradeSecurePassBanner:false
    };

    constructor() {
        if (this.configJs?.type === 311) {
            this.config = this.betaConfig;
        } else {
            this.config = this.prodConfig;
        }
        this.conditions = JSON.parse(JSON.stringify(this.config));
    }

    get() {
        return this.config;
    }

    deployTypeIsBeta() {
        return this.config.type === DeployType.BETA;
    }

    deployTypeIsProd() {
        return this.config.type === DeployType.PROD;
    }

    getDeployType(): DeployType {
        return this.config.type;
    }

    accountIsExternal() {
        return this.config?.account?.version === AccountVersion.EXTERNAL;
    }

    getChangePassword() {
        return this.conditions?.account?.change_password;
    }

    getChangeEmail() {
        return this.conditions?.account?.change_email;
    }

    getDeleteAccount() {
        return this.conditions?.account?.delete_account;
    }

    getAdminPassword() {
        return this.conditions?.account?.admin_password;
    }

    getOriginalAdminPassword() {
        return this.config?.account?.admin_password;
    }

    setAccountPaswword(showAdminPassword) {
        this.conditions.account.admin_password = showAdminPassword;
    }

    getAccountProfile() {
        return this.conditions?.account?.profile;
    }

    getAccountSettings() {
        return this.conditions?.account?.settings;
    }

    getAccountSessions() {
        return this.conditions?.account?.sessions;
    }

    getReccomendationsCard() {
        return this.conditions?.dashboard && this.conditions?.dashboardCards?.recommendations;
    }

    getNotifications() {
        return this.conditions?.notifications;
    }

    /**
     * Gets the preseted value of notifications config flag
     * @returns {boolean} the original value of notifications config flag
     */
    public getOriginalNotifications(): boolean {
        return this.config?.notifications;
    }

    public getOriginalBusinessDashboard(): boolean {
        return this.config?.business?.dashboard;
    }

    setNotifications(showNotifications) {
        this.conditions.notifications = showNotifications;
    }

    getDashboard() {
        return this.conditions?.dashboard;
    }

    public getBusinessDashboard(): boolean {
        return this.conditions?.business?.dashboard;
    }

    /**
     * Gets the original value of dashboard page config flag
     * @public
     * @memberof ConfigService
     * @returns {boolean} The value of the original flag
     */
    public getOriginalFamilyDashboard(): boolean {
        return this.config?.business?.dashboard;
    }

    /**
     * Gets the computed value of family dashboard page config flag
     * @public
     * @memberof ConfigService
     * @returns {boolean} The value of the flag
     */
    public getFamilyDashboard(): boolean {
        return this.conditions?.family?.dashboard;
    }

    /**
     * Gets the preseted value of dashboard page config flag
     * @returns {boolean} the original value of dashboard page config flag
     */
    public getOriginalDashboard(): boolean {
        return this.config?.dashboard;
    }

    setDashboard(showDashboard) {
        this.conditions.dashboard = showDashboard;
    }

    public setBusinessDashboard(showDashboard): void {
        this.conditions.business.dashboard = showDashboard;
    }

    /**
     * Sets the computed value of family dashboard page config flag
     * @public
     * @memberof ConfigService
     * @param {boolean} showDashboard The value to set for the family dashboard
     */
    public setFamilyDashboard(showDashboard: boolean): void {
        this.conditions.family.dashboard = showDashboard;
    }

    getDevices() {
        return this.conditions?.devicesTab;
    }

    /**
     * Gets the preseted value of devices page config flag
     * @returns {boolean} the original value of devices page config flag
     */
    public getOriginalDevices(): boolean {
        return this.config?.devicesTab;
    }

    setDevices(showDevicesTab) {
        this.conditions.devicesTab = showDevicesTab;
    }

    getPremiumServices() {
        return this.conditions?.premium;
    }

    getOriginalPremiumServices() {
        return this.config?.premium;
    }

    setPremiumServices(showPremiumServices) {
        this.conditions.premium = showPremiumServices;
    }

    getSubscriptions() {
        return this.conditions?.subscriptions;
    }

    getOffers() {
        return this.conditions?.offers;
    }

    /**
     * Gets the preseted value of offers page config flag
     * @returns {boolean} the original value of offers page config flag
     */
    public getOriginalOffers(): boolean {
        return this.config?.offers;
    }

    setOffers(showOffers) {
        this.conditions.offers = showOffers;
    }

    getReferral() {
        return this.conditions?.referral;
    }

    /**
     * Gets the preseted value of referral config flag
     * @returns {boolean} the original value of referral config flag
     */
    public getOriginalReferral(): boolean {
        return this.config?.referral;
    }

    setReferral(showReferral) {
        this.conditions.referral = showReferral;
    }

    /**
     * Gets the flag for insternal support
     * @returns {boolean} True if internal support is enabled
     */
    public getInternalSupport(): boolean {
        return this.conditions?.internalSupport;
    }

    /**
     * Gets whether support is available or not (inernal or external)
     * @returns {boolean} True if support is available
     */
    public getSupport(): boolean {
        return this.getInternalSupport() || this.getExternalSupport();
    }

    /**
     * Gets the preseted value of support page config flag
     * @returns {boolean} the original value of support page config flag
     */
    public getOriginalSupport(): boolean {
        return this.config?.support;
    }

    /**
     * Gets the preseted value of multiple payment cards used in payment details modal
     * @public
     * @memberof ConfigService
     * @returns {boolean} the original value of config flag
     */
    public getMultiplePaymentCards(): boolean {
        return this.conditions?.multiplePaymentCards;
    }

    /**
     * Sets the computed value of support page config flag
     * @param {boolean} showSupport True if support page should be shown
     */
    public setSupport(showSupport: boolean): void {
        this.conditions.support = showSupport;
    }

    getSupportContact() {
        return (this.getSupportEmail() || this.getSupportPhone());
    }

    getInfo() {
        return this.conditions?.info;
    }

    getOnboardingMSP() {
        return this.conditions?.onboardingMSP;
    }

    getOriginalCommunity() {
        return this.config?.community;
    }

    getCommunity() {
        return this.conditions?.community;
    }

    setNCCTopics(topics) {
        this.conditions.parentalNccElements.contentFiltering.topics = topics;
    }

    setNCCSafeSearch(safeSearch) {
        this.conditions.parentalNccElements.contentFiltering.safeSearch = safeSearch;
    }

    setNCCYoutubeRestricted(youtubeRestricted) {
        this.conditions.parentalNccElements.contentFiltering.youtubeRestricted = youtubeRestricted;
    }

    setNCCReward(reward) {
        this.conditions.parentalNccElements.dtl.reward = reward;
    }

    setNCCNeedMoreTime(needMoreTime) {
        this.conditions.parentalNccElements.dtl.needMoreTime = needMoreTime;
    }

    setNCCRoutines(routines) {
        this.conditions.parentalNccElements.routines.module = routines;
    }

    setNCCLocation(location) {
        this.conditions.parentalNccElements.dashboard.location = location;
    }

    /**
     * Set Ncc Blocked content categories state
     * @param {boolean} state
     * @memberof ConfigService
     */
    setNCCBlockedContentHasCategories(state: boolean): void {
        this.conditions.parentalNccElements.blockedContent.hasCategories = state;
    }
    /**
     * Set Ncc Blocked content topics state
     * @param {boolean} state
     * @memberof ConfigService
     */
    setNCCBlockedContentHasTopics(state: boolean): void {
        this.conditions.parentalNccElements.blockedContent.hasTopics = state;
    }

    /**
     * Set Ncc Blocked content websites state
     * @param {boolean} state
     * @memberof ConfigService
     */
    setNCCBlockedContentHasWebsites(state: boolean): void {
        this.conditions.parentalNccElements.blockedContent.hasWebsites = state;
    }

    getOriginalNCCTopics() {
        return this.config.parentalNccElements.contentFiltering.topics;
    }

    getOriginalNCCSafeSearch() {
        return this.config.parentalNccElements.contentFiltering.safeSearch;
    }

    getOriginalNCCYoutubeRestricted() {
        return this.config.parentalNccElements.contentFiltering.youtubeRestricted;
    }

    getOriginalNCCReward() {
        return this.config.parentalNccElements.dtl.reward;
    }

    getOriginalNCCNeedMoreTime() {
        return this.config.parentalNccElements.dtl.needMoreTime;
    }

    getOriginalNCCRoutines() {
        return this.config.parentalNccElements.routines.module;
    }

    getOriginalNCCLocation() {
        return this.config.parentalNccElements.dashboard.location;
    }

    /**
     * Get Original Ncc Blocked content categories state
     * @return {*}  {boolean}
     * @memberof ConfigService
     */
    getOriginalNCCBlockedContentHasCategories(): boolean {
        return this.config.parentalNccElements.blockedContent.hasCategories;
    }

    /**
     * Get Original Ncc Blocked content topics state
     * @return {*}  {boolean}
     * @memberof ConfigService
     */
    getOriginalNCCBlockedContentHasTopics(): boolean {
        return this.config.parentalNccElements.blockedContent.hasTopics;
    }

    /**
     * Get Original Ncc Blocked content websites state
     * @return {*}  {boolean}
     * @memberof ConfigService
     */
    getOriginalNCCBlockedContentHasWebsites(): boolean {
        return this.config.parentalNccElements.blockedContent.hasWebsites;
    }

    getNCCTopics() {
        return this.conditions.parentalNccElements.contentFiltering.topics;
    }

    getNCCSafeSearch() {
        return this.conditions.parentalNccElements.contentFiltering.safeSearch;
    }

    getNCCYoutubeRestricted() {
        return this.conditions.parentalNccElements.contentFiltering.youtubeRestricted;
    }

    getNCCReward() {
        return this.conditions.parentalNccElements.dtl.reward;
    }

    getNCCNeedMoreTime() {
        return this.conditions.parentalNccElements.dtl.needMoreTime;
    }

    getNCCRoutines() {
        return this.conditions.parentalNccElements.routines.module;
    }

    /**
     * Whether routines should use the legacy flat per-weekday schedule editor instead of schedulesets.
     * @returns {boolean} True when the legacy schedule editor should be used.
     */
    public getNCCUseScheduleLegacy(): boolean {
        return this.conditions?.parentalNccElements?.useScheduleLegacy;
    }

    getNCCLocation() {
        return this.conditions.parentalNccElements.dashboard.location;
    }

    getNCCPin() {
        return this.conditions.parentalNccElements.pin;
    }

    /**
     * Get Ncc Blocked content categories state
     * @return {*}  {boolean}
     * @memberof ConfigService
     */
    getNCCBlockedContentHasCategories(): boolean {
        return this.conditions.parentalNccElements.blockedContent.hasCategories;
    }

    /**
     * Get Ncc Blocked content topics state
     * @return {*}  {boolean}
     * @memberof ConfigService
     */
    getNCCBlockedContentHasTopics(): boolean {
        return this.conditions.parentalNccElements.blockedContent.hasTopics;
    }

    /**
     * Get Ncc Blocked content websites state
     * @return {*}  {boolean}
     * @memberof ConfigService
     */
    getNCCBlockedContentHasWebsites(): boolean {
        return this.conditions.parentalNccElements.blockedContent.hasWebsites;
    }

    /**
     * Get Ncc Blocked content state if we have catgories and another tab
     * @return {*}  {boolean}
     * @memberof ConfigService
     */
    getNCCBlockedContentCategoriesAndOther(): boolean {
        return this.getNCCBlockedContentHasCategories()
                && (this.getNCCBlockedContentHasTopics()
                || this.getNCCBlockedContentHasWebsites());
    }

    /**
     * Get Ncc Blocked content state
     * @return {*}  {boolean}
     * @memberof ConfigService
     */
    getNCCBlockedContent(): boolean {
        return this.getNCCBlockedContentHasCategories()
                || this.getNCCBlockedContentHasTopics()
                || this.getNCCBlockedContentHasWebsites();
    }

    setCommunity(showCommunity) {
        this.conditions.community = showCommunity;
    }

    getSubscriptionsBilling() {
        return this.conditions?.subscriptionsTabs?.billing;
    }

    setSubscriptionsBilling(showSubscriptionsBilling) {
        this.conditions.subscriptionsTabs.billing = showSubscriptionsBilling;
    }

    getSubscriptionsInvoices() {
        return this.conditions?.subscriptionsTabs?.invoices;
    }

    setSubscriptionsInvoices(showSubscriptionsInvoices) {
        this.conditions.subscriptionsTabs.invoices = showSubscriptionsInvoices;
    }

    getSubscriptionsPayments() {
        return this.conditions?.subscriptionsTabs?.payments;
    }

    setSubscriptionsPayments(showSubscriptionsPayments) {
        this.conditions.subscriptionsTabs.payments = showSubscriptionsPayments;
    }

    getSubscriptionsTab(pathname) {
        return this.conditions?.subscriptionsTabs?.[pathname];
    }

    getSupportEmail() {
        return this.conditions?.support && this.conditions?.supportCards?.email;
    }

    /**
     * Gets the flag for privacy chat
     * @returns {boolean} True if the chat can appear
     */
    public getPrivacyChat(): boolean {
        return this.conditions?.privacyChat;
    }

    getSupportPhone() {
        return this.conditions?.support && this.conditions?.supportCards?.phone;
    }

    getSupportSearch() {
        return this.conditions?.support && this.conditions?.supportCards?.search;
    }

    getOriginalSupportSearch() {
        return this.config?.support && this.config?.supportCards?.search;
    }

    setSupportSearch(showSupportSearch) {
        this.conditions.supportCards.search = showSupportSearch;
    }

    getDashboardSecurityNews() {
        return this.conditions?.dashboard && this.conditions?.dashboardCards?.securityNews;
    }

    getDashboarAppBanner() {
        return this.conditions?.dashboard && this.conditions?.dashboardCards?.appBanner;
    }

    getSiteUrl() {
        return this.config?.siteUrl;
    }

    getCentralBitdefenderSiteUrl() {
        return this.centralBitdefenderSiteUrl;
    }

    getCentralBetaBitdefenderSiteUrl() {
        return this.centralBetaBitdefenderSiteUrl;
    }

    getCentralAlphaBitdefenderSiteUrl() {
        return this.centralAlphaBitdefenderSiteUrl;
    }

    getChangeEmailUrl() {
        return this.config?.loginChangeEmail;
    }

    /**
     * Get external link for Account Authentication page
     * @return {*}  {string}
     * @memberof ConfigService
     */
    public getExternalAuthenticationAccountLink(): string {
        return this.conditions?.externalAuthenticationAccountLink;
    }

    getCookiesDomain() {
        return this.config?.cookiesDomain;
    }

    getQrCode() {
        return this.conditions?.qrCode;
    }

    getCookieConsent() {
        return this.conditions?.cookieConsent;
    }

    getOmniture() {
        return this.conditions?.omniture;
    }

    getSubscriptionsSdk() {
        return this.conditions?.subscriptionsSdk;
    }

    getManufacturerName() {
        return this.conditions?.manufacturerName;
    }

    getDownloadFooter() {
        return this.conditions?.downloadElements?.footer;
    }

    getDownloadHeaderLogo() {
        return this.conditions?.downloadElements?.headerLogo;
    }

    getDownloadBenefitsLogo() {
        return this.conditions?.downloadElements?.benefitsLogo;
    }

    getDownloadCommonHelpSection() {
        return this.conditions?.downloadElements?.commonHelpSection;
    }
    getOnBoardingManufacturerLogo() {
        return this.conditions?.onBoardingSection?.backgroundLogo;
    }

    getPasswordManagerNeedHelp() {
        return this.conditions?.passwordManagerCards?.needHelp;
    }

    getVpnUpgrade() {
        return this.conditions?.vpnCards?.upgrade;
    }

    getKatastifService() {
        return this.conditions?.katastifService;
    }

    getSentryAngular() {
        return this.conditions?.sentryAngular;
    }

    getSentryConnect() {
        return this.conditions?.sentryConnect;
    }

    getExternalSupport() {
        return this.conditions?.externalSupport;
    }

    /**
     * Gets the preseted value of external support config flag
     * @returns {boolean} the original value of external support config flag
     */
    public getOriginalExternalSupport(): boolean {
        return this.config?.externalSupport;
    }

    /**
     * Gets the preseted value of auto renewal flow config flag
     * @public
     * @memberof ConfigService
     * @returns {boolean} The value of the flag
     */
    public getAutoRenewalFlow(): boolean {
        return this.conditions?.autoRenewalFlow;
    }

    setExternalSupport(showExternalSupport) {
        this.conditions.externalSupport = showExternalSupport;
    }

    /**
     * Gets the preseted value of service details website link config flag
     * @public
     * @memberof ConfigService
     * @returns {boolean} The original value of the websites flag
     */
    public getServiceDetailsWebsite(): boolean {
        return !!this.conditions?.serviceDetailsLinks?.website;
    }

    getServiceDetailsFeatures() {
        return this.conditions?.serviceDetailsLinks?.features;
    }

    getServiceDetailsRequirements() {
        return this.conditions?.serviceDetailsLinks?.requirements;
    }

    getHome() {
        return this.conditions?.home;
    }

    getHomeSectionCapabilities() {
        return this.conditions?.homeSections.capabilities;
    }

    getHomeSectionProducts() {
        return this.conditions?.homeSections.products;
    }

    getHomeSectionAppBanner() {
        return this.conditions?.homeSections.appBanner;
    }

    getHomeSectionCapabilityDeviceProtection() {
        return this.conditions?.homeSections.capabilitiesList.deviceProtection;
    }

    getHomeSectionCapabilityRemoteActions() {
        return this.conditions?.homeSections.capabilitiesList.remoteActions;
    }

    getHomeSectionCapabilityInstallProtection() {
        return this.conditions?.homeSections.capabilitiesList.installProtection;
    }

    getHomeSectionCapabilityManageServices() {
        return this.conditions?.homeSections.capabilitiesList.manageServices;
    }

    getHomeSectionCapabilityParentalControl() {
        return this.conditions?.homeSections.capabilitiesList.parentalControl;
    }

    getHomeSectionCapabilityIndustryInsights() {
        return this.conditions?.homeSections.capabilitiesList.industryInsights;
    }

    getInstallProtectionShowLogo() {
        return this.config.installProtection.showLogo;
    }

    getInstallProtectionLogoPath() {
        return this.config.installProtection.customLogoPath !== "" ? this.config.installProtection.customLogoPath : null;
    }

    setPrivacyActivity(showPrivacyActivity) {
        this.conditions.privacyTabs.activity = showPrivacyActivity;
    }

    getPrivacyActivity() {
        return this.conditions?.privacyTabs?.activity;
    }

    setPrivacyFootprint(showPrivacyFootprint) {
        this.conditions.privacyTabs.footprint = showPrivacyFootprint;
    }

    getPrivacyFootprint() {
        return this.conditions?.privacyTabs?.footprint;
    }

    setPrivacyBreaches(showPrivacyBreaches) {
        this.conditions.privacyTabs.breaches = showPrivacyBreaches;
    }

    getPrivacyBreaches() {
        return this.conditions?.privacyTabs?.breaches;
    }

    setPrivacyImpersonations(showPrivacyImpersonations) {
        this.conditions.privacyTabs.impersonations = showPrivacyImpersonations;
    }

    getPrivacyImpersonations() {
        return this.conditions?.privacyTabs?.impersonations;
    }

    setPrivacyBrokers(showPrivacyBrokers) {
        this.conditions.privacyTabs.brokers = showPrivacyBrokers;
    }

    getPrivacyBrokers() {
        return this.conditions?.privacyTabs.brokers;
    }

    setPrivacyEducation(showPrivacyEducation) {
        this.conditions.privacyTabs.education = showPrivacyEducation;
    }

    getPrivacyEducation() {
        return this.conditions?.privacyTabs.education;
    }

    setPrivacyHistory(showPrivacyHistory) {
        this.conditions.privacyTabs.history = showPrivacyHistory;
    }

    getPrivacyHistory() {
        return this.conditions?.privacyTabs.history;
    }

    /**
     * Gets the privacy monitor flag.
     * @returns {boolean} True if the privacy monitor tab should be shown.
     */
    public getPrivacyRemedies(): boolean {
        return this.conditions?.privacyTabs.remedies;
    }

    setPrivacyMonitor(showPrivacyMonitor) {
        this.conditions.privacyTabs.monitor = showPrivacyMonitor;
    }

    /**
     * Sets the privacy remedies flag.
     * @param {boolean} showPrivacyRemedies True if the privacy remedies tab should be shown.
     */
    public setPrivacyRemedies(showPrivacyRemedies: boolean): void {
        this.conditions.privacyTabs.remedies = showPrivacyRemedies;
    }

    getPrivacyMonitor() {
        return this.conditions?.privacyTabs.monitor;
    }

    /**
     * Gets the gmail auth client id.
     * @returns {string} The gmail auth client id.
     */
    public getGmailAuthClientId(): string {
        return this.conditions?.gmailAuth?.clientId;
    }

    /**
     * Gets the outlook auth client id.
     * @returns {string} The outlook auth client id.
     */
    public getOutlookAuthClientId(): string {
        return this.conditions?.outlookAuth?.clientId;
    }

    /**
     * Get Google Maps Api link
     * @return {*}  {string}
     * @memberof ConfigService
     */
    public getGoogleMapsApiLink(): string {
        return this?.conditions?.googleMapsApi ?? '';
    }

    /**
     * Gets the config flag for security tab.
     * @returns {boolean} True if the security tab should be shown.
     */
    public getSecurityModule(): boolean {
        return this.conditions?.security;
    }

    /**
     * Gets the config flag for ato tab.
     * @returns {boolean} True if the ato tab should be shown.
     */
    public getAtoModule(): boolean {
        return this.conditions?.ato;
    }

    /**
     * Gets the config flag for meta
     * @returns {boolean} True if the meta channels should be shown.
     */
    public getMeta(): boolean {
        return this.conditions?.meta;
    }

    /**
     * Sets the config flag for security tab.
     * @param {boolean} security True if the security tab should be shown.
     */
    public setSecurityModule(security: boolean): void {
        this.conditions.security = security;
    }

    /**
     * Sets the config flag for ato tab.
     * @param {boolean} ato True if the ato tab should be shown.
     */
    public setAtoModule(ato: boolean): void {
        this.conditions.ato = ato;
    }

    /**
     * Gets the original config flag for security module.
     * @returns {boolean} True if the security module should be shown.
     */
    public getOriginalSecurityModule(): boolean {
        return this.config?.security;
    }

    /**
     * Gets the original config flag for ato module.
     * @returns {boolean} True if the ato module should be shown.
     */
    public getOriginalAtoModule(): boolean {
        return this.config?.ato;
    }

    /**
     * Gets the config flag for security overview tab.
     * @returns {boolean} True if the security overview tab should be shown.
     */
    public getSecurityOverview(): boolean {
        return this.conditions?.securityTabs.overview;
    }

    /**
     * Gets the original config flag for security overview tab.
     * @returns {boolean} True if the security overview tab should be shown.
     */
    public getOriginalSecurityOverview(): boolean {
        return this.config?.securityTabs.overview;
    }

    /**
     * Gets the config flag for security email protection tab.
     * @returns {boolean} True if the security email protection tab should be shown.
     */
    public getSecurityWebmailProtection(): boolean {
        return this.conditions?.securityTabs.webmailProtection;
    }

    /**
     * Gets the config flag for ato threats devices tab
     * @returns {boolean} True if the tab should be shown
     */
    public getAtoThreatsDevices(): boolean {
        return this.conditions?.atoThreatsTabs.devices;
    }

    /**
     * Gets the config flag for ato threats email protection tab
     * @returns {boolean} True if the tab should be shown
     */
    public getAtoThreatsEmailProtection(): boolean {
        return this.conditions?.atoThreatsTabs.emailProtection;
    }

    /**
     * Sets the config flag for security email protection tab.
     * @param {boolean} webmailProtection True if the security email protection tab should be shown.
     */
    public setSecurityWebmailProtection(webmailProtection: boolean): void {
        this.conditions.securityTabs.webmailProtection = webmailProtection;
    }

    /**
     * Sets the config flag for security overview tab.
     * @param {boolean} overview True if the security overview tab should be shown.
     */
    public setSecurityOverview(overview: boolean): void {
        this.conditions.securityTabs.overview = overview;
    }

    /**
     * Gets the original config flag for security email protection tab.
     * @returns {boolean} True if the security email protection tab should be shown.
     */
    public getOriginalSecurityWebmailProtection(): boolean {
        return this.config?.securityTabs.webmailProtection;
    }

    /**
     * Gets the original config flag for buy rights.
     * @returns {boolean} original buy rights flag value
     */
    public getOriginalBuyRights(): boolean {
        return this.config?.rights?.buy;
    }

    /**
     * Gets the original config flag for activate redeem rights.
     * @returns {boolean} original activate redeem rights flag value
     */
    public getOriginalActivateRedeemRights(): boolean {
        return this.config?.rights?.activateRedeem;
    }

    /**
     * Gets the config flag for buy rights.
     * @returns {boolean} buy rights flag value
     */
    public getBuyRights(): boolean {
        return this.conditions.rights.buy;
    }

    /**
     * Sets the config flag for buy rights.
     * @param {boolean} buyRights new flag value
     */
    public setBuyRights(buyRights: boolean): void {
        this.conditions.rights.buy = buyRights;
    }

    /**
     * Sets the config flag for buy more slots rights.
     * @param {boolean} buyRights new flag value
     */
    public setBuyMoreSlotsRights(buyMoreSlotsRights: boolean): void {
        this.conditions.rights.buyMoreSlots = buyMoreSlotsRights;
    }

    /**
     * Sets the original config flag for activate redeem rights.
     * @param {boolean} activateRedeem new flag value
     */
    public setActivateRedeemRights(activateRedeem): void {
        return this.conditions.rights.activateRedeem = activateRedeem;
    }

    /**
     * Gets the original config flag for buy more slots rights.
     * @returns {boolean} original buy more slots rights flag value
     */
    public getOriginalBuyMoreSlotsRights(): boolean {
        return this.config?.rights?.buyMoreSlots;
    }

    /**
     * Gets the config flag for buy more slots rights.
     * @returns {boolean} buy more slots rights flag value
     */
    public getBuyMoreSlotsRights(): boolean {
        return this.conditions.rights.buyMoreSlots;
    }

    /**
     * Gets the config flag for activate redeem rights.
     * @returns {boolean} activate redeem rights flag value
     */
    public getActivateRedeemRights(): boolean {
        return this.conditions.rights.activateRedeem;
    }

    /**
     *
     * Get manifest path
     * @return {*}  {string}
     * @memberof ConfigService
     */
    public getPwaManifestPath(): string {
        return this?.conditions?.pwaSettings.manifestPath ?? "";
    }

    /**
     *
     * Get OS specific manifest path
     * @return {*}  {string}
     * @memberof ConfigService
     * @param {string} os
     */
    public getPwaManifestPathByOs(os): string {
        return this?.conditions?.pwaSettings.manifestByOs[os] ?? this.getPwaManifestPath();
    }

    /**
     *
     * Get Service worker path
     * @return {*}  {string}
     * @memberof ConfigService
     */
    public getPwaSwPath(): string {
        return this?.conditions?.pwaSettings.serviceWorkerPath ?? "";
    }

    /**
     * Gets the secure pass server URL
     * @returns {string} The secure pass server URL
     */
    public getSecurePassServer(): string {
        return this.conditions?.securePassServer;
    }

    /**
     * Gets the ts trial id for automatic activation
     * @returns {string} The trial id
     */
    public getTrialId(): string {
        return this.config?.ts_trial_id;
    }

     /**
     * Gets the config flag for ts trial automatic activation.
     * @returns {boolean} flag value
     */
    public getAutomaticTrialActivation() {
        return this.conditions?.automaticTrialActivation;
    }
     /**
     * Gets the config flag for remove switch & upgrade SecurePass call inside /secure-pass page
     * @returns {boolean} flag value
     */
    public getRemoveSwitchAndUpgradeSecurePassBanner() {
        return this.conditions?.removeSwitchAndUpgradeSecurePassBanner;
    }
}
